import { BiCheck } from 'react-icons/bi'
export const ServicesData=[
    {
        company: 'ISANGO!',
        title: 'Associate Software Engineer',
        link:'https://www.isango.com/',
        data: <ul className='service__list'>
        <li>
          <BiCheck className='service__list-icon'/>
          <p>Developed B2C, B2B applications and hosted on Microsoft Azure IaaS & Paas which increases user experience by 26%.</p>
        </li>

        <li>
          <BiCheck className='service__list-icon'/>
          <p>Redesigned the whole site framework with Sitecore CMS by following Helix Architecture. It helped to gain the viewer experience by 14%. </p>
        </li>

        <li>
          <BiCheck className='service__list-icon'/>
          <p>Improved performance of SEO by providing efficient infrastructure to personalized keywords in Sitecore CMS.</p>
        </li>

        <li>
          <BiCheck className='service__list-icon'/>
          <p>Embedded the CloudFare API for serving CDN-based images to ameliorate image quality of the whole website by 45%.</p>
        </li>

      </ul>
    },





    {
        company: 'PUBLICIS SAPIENT',
        title:'Software Engineer II',
        link: 'https://www.publicissapient.com/work/how-miral-connects-customer-experience-travelers',
        data: <ul className='service__list'>
        <li>
          <BiCheck className='service__list-icon'/>
          <p>Re-Engineered and implemented a multi-tenant and multilingual platform to make it one of the most flexible and cost
effective solutions using Microsoft Azure.</p>
        </li>

        <li>
          <BiCheck className='service__list-icon'/>
          <p>Analyzed and worked on bugs which improved the performance of ticket buying widget by 14% and overall sale by 8%.</p>
        </li>

        <li>
          <BiCheck className='service__list-icon'/>
          <p>Orchestrated CMS to streamline the flow of data between Multi-Lingual websites and their respective mobile application.</p>
        </li>

        <li>
          <BiCheck className='service__list-icon'/>
          <p>Integrated Coveo ML API in the search component of the platform which escalated search rate by 29%.</p>
        </li>

      </ul>


    },



    {
        company: 'RUTGERS UNIVERSITY',
        title: 'Software Engineering Intern',
        link:'https://codebench.cs.rutgers.edu/',
        data: <ul className='service__list'>
        <li>
          <BiCheck className='service__list-icon'/>
          <p>Overhauled the conventional University grading system by providing new tools that will improve efficiency and boost
student participation by 21%.</p>
        </li>

        <li>
          <BiCheck className='service__list-icon'/>
          <p>Revamp continuous integration (CI) and continuous delivery (CD) pipeline thus increased code delivery speed by 7%.
</p>
        </li>

        <li>
          <BiCheck className='service__list-icon'/>
          <p>Jupyter Lab has been integrated with Nbgrader, which will automate the submission process. Cloud-based delivery will be used for all student submissions.</p>
        </li>

        <li>
          <BiCheck className='service__list-icon'/>
          <p>Incorporated a new tool, CodePost into the application which will improve the user experience of graders and instructors.</p>
        </li>
      </ul>
    },

    {
      company: 'HORIZONTAL DIGITAL',
      title: 'Senior Application Engineer',
      link:'https://www.horizontal.com/',
      data: <ul className='service__list'>
      <li>
        <BiCheck className='service__list-icon'/>
        <p>Built a dynamic security header management system using Next.js and GraphQL, improving security compliance across 5+ sites.</p>
      </li>

      <li>
        <BiCheck className='service__list-icon'/>
        <p>Led Azure SSO integration with Sitecore CMS, reducing user login errors by 9%.</p>
      </li>

      <li>
        <BiCheck className='service__list-icon'/>
        <p>Automated Monorepo setup and Docker-based CI/CD pipelines on AWS, accelerating multi-site deployment to Vercel.</p>
      </li>

      <li>
        <BiCheck className='service__list-icon'/>
        <p>Developed editor-driven dynamic UI components in Tailwind CSS, improving accessibility and consistency.</p>
      </li>
    </ul>
  }



]